// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"d08bed4b","667":"0aa4b22b"}[chunkId] + ".chunk.js";
};